import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../Components/PreOrderTicketCard/TicketCard.css";
import { FiArrowRight } from "react-icons/fi";
import pingleLogo from "../../Assets/Images/pingle.png";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import eggIcon from "../../Assets/Images/eggpngoutput.png"

export default function KitchenMembershipdetailCard({ item, pageName }) {

    const DEFAULT_Ticket_IMAGE_URL =
        "https://theme-assets.getbento.com/sensei/6941e9b.sensei/assets/images/catering-item-placeholder-704x520.png";
    const DEFAULT_IMAGE_URL =
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScO99JkPvdfSyT3CbMrYsKBpRuXOACVR2cP9F6DBcP9B6nQ9oszX_18T-2oNv6Gyxwyhk&usqp=CAU";

    const { vendor_id } = useParams();
    const textRef = useRef(null);
    const [lineWidth, setLineWidth] = useState(0);
    const [data, setData] = useState(item);
    const navigate = useNavigate();
    const [showContainer, setShowContainer] = useState(true);

    useEffect(() => {
        if (textRef.current) {
            setLineWidth(textRef.current.offsetWidth);
        }
    }, [data.ticket_name]);

    const [timeLeft, setTimeLeft] = useState({
        minutes: 0,
        seconds: 0,
        expired: false
    });

    const [status, setStatus] = useState("before");


    const MEAL_START_TIME = {
        1: "06:00",
        2: "17:00",
        3: "12:00",
        4: "15:00",
        5: "18:00",
        6: "22:00",
    };


    // 3️⃣ HELPERS
    const getBookingWindow = (meal_time, book_before_time) => {
        const start = MEAL_START_TIME[meal_time];
        if (!start) return null;

        const [h, m] = start.split(":").map(Number);

        const mealStart = new Date();
        mealStart.setHours(h, m, 0, 0);

        const bookingClose = new Date(mealStart);
        bookingClose.setHours(
            bookingClose.getHours() - Number(book_before_time)
        );

        const bookingStart = new Date(bookingClose);
        bookingStart.setHours(bookingStart.getHours() - 1);

        return { bookingStart, bookingClose };
    };


    const getRemainingTime = (endTime) => {
        const diff = endTime - new Date();

        if (diff <= 0) {
            return { minutes: 0, seconds: 0, expired: true };
        }

        const totalSeconds = Math.floor(diff / 1000);

        return {
            minutes: Math.floor(totalSeconds / 60),
            seconds: totalSeconds % 60,
            expired: false
        };
    };


    useEffect(() => {
        if (!data?.meal_time || !data?.book_before_time) return;

        const window = getBookingWindow(
            data.meal_time,
            data.book_before_time
        );

        if (!window) return;

        const interval = setInterval(() => {
            const now = new Date();

            if (now < window.bookingStart) {
                setStatus("before");
            }
            else if (now >= window.bookingClose) {
                setStatus("closed");
                setTimeLeft({ minutes: 0, seconds: 0, expired: true });
                clearInterval(interval);
            }
            else {
                setStatus("active");
                setTimeLeft(getRemainingTime(window.bookingClose));
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [data?.meal_time, data?.book_before_time]);

    console.log('data----------', data);

    return (

        // <div>
        //     <section className="section-spaces">
        //         <div className="kitchen-membershipDetail-card group">
        //             <div className="kitchen-membership-image-wrapper">
        //                 <img src={data?.ticket_image
        //                     ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${data?.ticket_image}`
        //                     : DEFAULT_Ticket_IMAGE_URL}
        //                     alt="Chicken Biryani"
        //                     className="kitchen-membership-image"
        //                 />

        //                 <div className="kitchen-membership-overlay" ></div>

        //                 <div className="kitchen-membership-content">
        //                     <h2 className="kitchen-membershipDetail-title">
        //                         {data?.ticket_name}
        //                     </h2>
        //                     <p className="kitchen-membership-desc">
        //                         {data?.about_ticket}
        //                     </p>
        //                 </div>

        //             </div>
        //         </div>
        //     </section>
        // </div>


        <div className="buyedkitchechmembership-card">
            <div className="buyedkitchechmembership-inner">

                {/* Image */}
                <div className="buyedkitchechmembership-image">

                    <img src={data?.ticket_image
                        ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${data?.ticket_image}`
                        : DEFAULT_Ticket_IMAGE_URL}
                        alt="Chicken Biryani"
                        className="buyedkitchechmembership-img"
                    />
                </div>

                {/* Content */}
                <div className="buyedkitchechmembership-content">

                    {/* Left */}
                    <div className="buyedkitchechmembership-info">
                        <div className="buyedkitchechmembership-title-row">

                            <h3 className="buyedkitchechmembership-title">
                                <img
                                    src={item?.ticket_food_type == "1" ? vegIcon : nonvegIcon}
                                    alt={item?.ticket_food_type}
                                    className="buyedkitchechmembership-foodicon"
                                />
                                {item?.ticket_name}
                            </h3>

                            <span className="buyedkitchechmembership-activebadge">
                                Active
                            </span>
                        </div>

                        <p className="buyedkitchechmembership-desc">
                            {item?.about_ticket}
                        </p>
                    </div>

                    <div className="buyedkitchechmembership-action">
                        <div className="buyedkitchechmembership-price-box">
                            <span className="buyedkitchechmembership-price">
                                <span className="rupeeIcon">₹</span>{item?.ticket_price}
                            </span><br />
                            <span className="buyedkitchechmembership-subtext">
                                {new Date(item?.redeem_validity).toLocaleString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })}
                            </span>
                        </div>

                        <button className="buyedkitchechmembership-btn">
                            Subscription
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
}
